import { withI18n } from 'react-i18next';
import SortCard from './SortCard';

export const pureComponent = SortCard;
export default withI18n()(SortCard);
